<script lang="ts">
	import type { TeaserContent } from '../../../domain/teaser/TeaserContent.ts';
	import { onMount } from 'svelte';
	import { onViewport } from '../../../services/tracking/IntersectionObserver';
	import { TeaserType } from '../../../domain/teaser/TeaserType.ts';
	import { trackClick, trackSeen, trackView } from '../../../services/tracking/UpHomeServicePageTeaserTracking.ts';
	import TrackingService from '../../../services/tracking/TrackingService.ts';

	let trackingService: TrackingService;

	let { teaserContent }: {
		teaserContent: TeaserContent,
	} = $props();


	const onTeaserClicked = () => {
		trackClick(trackingService, {
			up_Promo: 'ToUpHome',
			up_TeaserType: TeaserType.TO_UP_HOME,
			up_TeaserSize: 'MediaObject100'
		});
	};


	const onTeaserSeen = () => {
		trackSeen(trackingService, {
			up_Promo: 'seen',
			up_TeaserType: TeaserType.TO_UP_HOME,
			up_TeaserSize: 'MediaObject100'
		});
	};

	onMount(() => {
		trackingService = new TrackingService();
		trackView(trackingService, {
			up_Promo: 'view',
			up_TeaserType: TeaserType.TO_UP_HOME,
			up_TeaserSize: 'MediaObject100'
		});
	});
</script>


<div class="oc-mt-100 oc-mb-150 oc-mx-100"
	data-testid="to-up-home"
	onclick={onTeaserClicked}
	use:onViewport
	onenterViewport={onTeaserSeen}
>
	<a class="pl_media-object_wrapper to-home-link" href="/myaccount/up">
		<div class="pl_media-object100--red">
			<div class="pl_media-object--image pl_media-object--icon">
				<svg class="pl_icon" id="pl_icon_otto-up" role="img">
					<use
						data-testid="pl_icon_otto-up"
						href="/assets-static/icons/pl_icon_otto-up.svg#pl_icon_otto-up"
						xlink:href="/assets-static/icons/pl_icon_otto-up.svg#pl_icon_otto-up"></use>
				</svg>
			</div>

			<div class="pl_media-object--content">
				<div class="pl_media-object--headline">
					<div>{teaserContent.heading}</div>
				</div>
				<div class="pl_media-object--subline">{teaserContent?.subheading}</div>
			</div>
		</div>
	</a>
</div>

<style lang="scss">
  .to-home-link {
    all: unset;
  }
</style>
